import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL, REPORT_BY_SALES_PERSON } from "../../../Constants/Config";
import { toThunkRejectValue } from "../../../Common/isRequestCanceled";

const initialState = {
  loading: false,
  SalePersonData: [],
  successMessage: "",
  error: "",
  latestRequestId: null,
};
let controller; // Store AbortController globally
// Generate pening , fulfilled and rejected action type
export const fetchSalePersonData = createAsyncThunk(
  "SalesByPersonSlice/fetchSalePersonData.",
  async (data, { rejectWithValue, requestId }) => {
    try {
      if (controller) {
        controller.abort();
      }

      // Create a new AbortController
      controller = new AbortController();
      const { signal } = controller;

      const { token, ...newData } = data;
      const response = await axios.post(
        BASE_URL + REPORT_BY_SALES_PERSON,
        newData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
          signal, // Attach the signal to axios request
        }
      );
      if (response.data.status === true) {
        // console.log(response.data);
        return { requestId, data: response.data.report_data };
      }
    } catch (error) {
      // throw new Error(error.response.data.message);
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

const SalesByPersonSlice = createSlice({
  name: "SalesByPersonSlice",
  initialState,
  reducers: {
    updateSalseByPersonState: (state) => {
      // Abort any ongoing API request
      if (controller) {
        controller.abort();
      }

      state.SalePersonData = [];
      state.loading = false;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(fetchSalePersonData.pending, (state, action) => {
      state.loading = true;
      state.latestRequestId = action.meta.requestId;
    });
    builder.addCase(fetchSalePersonData.fulfilled, (state, action) => {
      if (state.latestRequestId !== action.payload.requestId) {
        return; // Ignore outdated responses
      }
      state.loading = false;
      state.SalePersonData = action.payload.data;
      state.error = "";
    });
    builder.addCase(fetchSalePersonData.rejected, (state, action) => {
      if (state.latestRequestId !== action.payload?.requestId) {
        return; // Ignore outdated errors
      }
      if (action.payload?.message === "Request canceled") {
        return; // Do nothing if canceled, keep loading true
      }
      state.loading = false;
      state.SalePersonData = {};
      state.error = action.error.message;
    });
  },
});
export const { updateSalseByPersonState } = SalesByPersonSlice.actions;
export default SalesByPersonSlice.reducer;
